import { render, staticRenderFns } from "./manageGateways.vue?vue&type=template&id=af85c314&scoped=true"
import script from "./manageGateways.vue?vue&type=script&lang=js"
export * from "./manageGateways.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af85c314",
  null
  
)

export default component.exports